// import { getToysSortQuery, PageQueries } from '@specs/navigation'
// import React, { FC, useRef } from 'react'

// import { InfinityList } from '@components/InfinityList/InfinityList'
// import { ToyCard } from '@components/Cards/ToyCard/ToyCard'
// import { useGetPrivateToysInfinity } from '@hooks/TRPC_Hooks/useGetToys'
// import { useRouter } from 'next/router'

// interface Props { }

// const limit = 10

// export const ToysPrivateList: FC<Props> = ({ }) => {
//     const router = useRouter()
//     const enabledRef = useRef(false)
//     const { toysSort, query, priceSortCurrency, toysRarity }: PageQueries = router.query

//     const sort = getToysSortQuery(toysSort)

//     const {
//         data,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         status,
//     } = useGetPrivateToysInfinity({
//         limit,
//         sort,
//         query,
//         rarity: toysRarity,
//         currency: priceSortCurrency,
//     }, {
//         enabled: enabledRef.current,
//     })

//     return (
//         <InfinityList
//             fetchNextPage={fetchNextPage}
//             data={data}
//             hasNextPage={hasNextPage}
//             isFetchingNextPage={isFetchingNextPage}
//             status={status}
//             enabledRef={enabledRef}
//             listClassName={'_toysGrid'}
//         >
//             {(item) => (
//                 <ToyCard
//                     key={item.id}
//                     {...item}
//                 />
//             )}
//         </InfinityList>
//     )
// }

import React, { FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useGetPrivateToys } from '@hooks/TRPC_Hooks/useGetToys';
import { getToysSortQuery, PageQueries } from '@specs/navigation';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { PaginatedList } from '@components/PaginatedList/PaginatedList';
interface Props {}
const limit = 10;
export const ToysPrivateList: FC<Props> = () => {
  const router = useRouter();
  const gridRef = useRef<HTMLDivElement>(null);
  const {
    toysSort,
    query,
    priceSortCurrency,
    toysRarity,
    page = '1'
  }: PageQueries = router.query;
  const currentPage = Number(page);
  const prevPageRef = useRef<number>(currentPage);
  const pageChangeRef = useRef(false);
  const sort = getToysSortQuery(toysSort);
  const {
    data,
    status
  } = useGetPrivateToys({
    limit,
    skip: (currentPage - 1) * limit,
    sort,
    query,
    rarity: toysRarity,
    currency: priceSortCurrency
  });
  const handlePageChange = (newPage: number) => {
    pageChangeRef.current = true;
    router.push({
      query: {
        ...router.query,
        page: newPage.toString()
      }
    }, undefined, {
      scroll: false
    });
  };
  useEffect(() => {
    if (currentPage !== prevPageRef.current) {
      pageChangeRef.current = true;
      prevPageRef.current = currentPage;
    }
    if (pageChangeRef.current && status === 'success' && data?.items.length) {
      if (gridRef.current) {
        window.scrollTo({
          top: gridRef.current.offsetTop - 200,
          behavior: 'smooth'
        });
      }
      pageChangeRef.current = false;
    }
  }, [currentPage, status, data]);
  return <div ref={gridRef} data-sentry-component="ToysPrivateList" data-sentry-source-file="ToysPrivateList.tsx">
            <PaginatedList data={data} currentPage={currentPage} onPageChange={handlePageChange} status={status} listClassName="_toysGrid" data-sentry-element="PaginatedList" data-sentry-source-file="ToysPrivateList.tsx">
            {item => <ToyCard key={item.id} {...item} />}
            </PaginatedList>
        </div>;
};